export default __webpack_public_path__ + "static/media/arrange.efa5d6b9.svg";